export const MAX_ITEM_POWER = 900;
export const MAX_HERO_LEVEL = 70;

export const MAX_IMPLICIT_STATS_PER_ITEM = 2;
export const MAX_AFFIX_STATS_PER_ITEM = 6;